import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight, Search } from "lucide-react";
import Seo from "../components/Seo";

const QUICK_LINKS = [
  ["Our Services", "/services"],
  ["Pricing", "/pricing"],
  ["Legal Cashiering", "/legal-cashiering"],
  ["Insights", "/insights"],
  ["Contact", "/contact"],
];

export default function NotFound() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-white min-h-[70vh] flex items-center" data-testid="not-found-page">
      <Seo title="Page not found" description="Sorry, the page you were looking for doesn't exist or has moved." noindex />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-24 text-center">
        <span className="inline-flex items-center gap-2 text-orange font-bold text-sm tracking-widest uppercase mb-4">
          <Search size={16} /> Error 404
        </span>
        <h1 className="font-display font-extrabold text-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
          This page can't be found
        </h1>
        <p className="mt-6 text-base md:text-lg text-slate-500 max-w-xl mx-auto">
          The page you were looking for doesn't exist or may have moved. It might be from our previous website — let's get you back on track.
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" data-testid="not-found-home" className="inline-flex items-center gap-2 bg-orange hover:bg-orange-dark text-white font-bold px-8 py-4 rounded-full transition-all hover:-translate-y-0.5">
            <Home size={18} /> Back to homepage
          </Link>
          <Link to="/contact" data-testid="not-found-contact" className="inline-flex items-center gap-2 bg-navy hover:bg-navy-deep text-white font-bold px-8 py-4 rounded-full transition-all hover:-translate-y-0.5">
            Contact us <ArrowRight size={18} />
          </Link>
        </div>
        <div className="mt-12 pt-8 border-t border-slate-100">
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-400 mb-4">Popular pages</p>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
            {QUICK_LINKS.map(([label, url]) => (
              <Link key={url} to={url} className="text-sm font-semibold text-navy hover:text-orange transition-colors">{label}</Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
